/**
 * @format
 */
 import {connect} from 'react-redux';

import { UserListView } from '../component';
 
 const User = connect()(UserListView);
 
 export {User};